import {decodeJwtToken} from './decodeJwtToken';

const hasPassed = (time: number, secondsBuffer: number): boolean => {
  const msBuffer = secondsBuffer * 1000;
  const timeMs = time < 1000000000000 ? time * 1000 : time;
  return Date.now() + msBuffer > timeMs;
};

export function hasTokenExpired(token: string | undefined): boolean {
  if (!token) return true;

  const {exp} = decodeJwtToken(token);
  return hasPassed(exp, 2); // Subtract 2 sec to reduce sync issues
}
